import { useEffect, useRef } from 'react';

import { BEARER } from '@/api/api';
import { PATHS } from '@/common';
import CONFIG from '@/utils/config';
import Token from '@/utils/handlers/Token';

const deleteDocumentOnTabClose = (documentId: string) => {
  fetch(`${CONFIG.BASE_URL}${PATHS.DELETE_DOCUMENT(documentId)}`, {
    method: 'DELETE',
    keepalive: true,
    headers: {
      authorization: `${BEARER} ${Token.getToken()}`,
    },
  });
};

interface Props {
  documentId?: string;
  isCreatingClaim?: boolean;
  isClaimCreated?: boolean;
}

const useDeleteDocumentOnTabClose = ({ documentId, isCreatingClaim, isClaimCreated }: Props) => {
  const documentIdRef = useRef(documentId);
  const isCreatingClaimRef = useRef(isCreatingClaim);
  const isClaimCreatedRef = useRef(isClaimCreated);

  useEffect(() => {
    const handleBeforeUnload = () => {
      if (documentId && !isCreatingClaim && !isClaimCreated) {
        deleteDocumentOnTabClose(documentId);
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [documentId, isCreatingClaim, isClaimCreated]);


  useEffect(() => {
    documentIdRef.current = documentId;
    isCreatingClaimRef.current = isCreatingClaim;
    isClaimCreatedRef.current = isClaimCreated;
  }, [documentId, isCreatingClaim, isClaimCreated]);

  useEffect(() => {
    return () => {
      if (documentIdRef.current && !isCreatingClaimRef.current && !isClaimCreatedRef.current) {
        deleteDocumentOnTabClose(documentIdRef.current);
      }
    };
  }, []);
};

export default useDeleteDocumentOnTabClose;